import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { SERVER_DRIVEN_UI_TEST_MODE_ENABLED_240314 } from "@faire/web-api--source/indigofair/settings/SERVER_DRIVEN_UI_TEST_MODE_ENABLED_240314";

export const getSettingSDUITestModeEnabled = (): boolean =>
  getSettingValueWithoutAssignment(
    SERVER_DRIVEN_UI_TEST_MODE_ENABLED_240314,
    false
  );
